import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getCheckoutLuxLoyaltyPointBurnCalculationView from './getCheckoutLuxLoyaltyPointBurnCalculationView'

const getCheckoutLuxLoyaltyBurningPointItems = createSelector(
  (state: App.State) => state.checkout.luxLoyalty.pointsToBurn,
  (state: App.State) => getCheckoutLuxLoyaltyPointBurnCalculationView(state),
  (
    pointsToBurn,
    pointBurnCalculationView,
  ): Array<App.Checkout.LuxLoyaltyBurningPointItem> => {
    if (!pointsToBurn) return EmptyArray
    if (!pointBurnCalculationView.data) return EmptyArray
    if (pointBurnCalculationView.data.minBurnablePoints > pointsToBurn) return EmptyArray
    if (pointBurnCalculationView.data.items.length === 0) return EmptyArray

    const pointsToBurnPerItem: Array<App.Checkout.LuxLoyaltyBurningPointItem> = []
    let remainingPoints = pointsToBurn
    for (const item of pointBurnCalculationView.data.items) {
      if (remainingPoints <= 0) break
      const pointsPaid = item.priceInPoints <= remainingPoints ? item.priceInPoints : remainingPoints
      pointsToBurnPerItem.push({
        priceInCurrency: item.priceInCurrency,
        priceInPoints: item.priceInPoints,
        pointsPaid,
        productType: item.itemView.luxLoyaltyProductType!,
        mx: item.itemView.mx,
      })
      remainingPoints -= item.priceInPoints
    }

    if (!pointsToBurnPerItem.length) return EmptyArray

    return pointsToBurnPerItem
  },
)

export default getCheckoutLuxLoyaltyBurningPointItems
